interface ExtraSectionsLabels {
  title: string;
  total: string;
  conceptPath: string;
}

export const otherConcepts: ExtraSectionsLabels = {
  title: 'ds.basket.common.other_concepts.title',
  total: 'ds.basket.totals.otherConcepts',
  conceptPath: 'ds.basket.common.other_concepts.global_concepts'
};
